export default "__VITE_ASSET__BsVpui$b__"